import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const organizationinspection = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/organization-inspection',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'organizationinspection' }
    ),
    { }
  )
)()

export { organizationinspection, TYPES }
